import { useLocation, useNavigate } from 'react-router';

export type ProposalFormMode = 'create' | 'update';

interface UseProposalNavigationOptions {
  mode: ProposalFormMode;
  proposalId?: string;
}

/**
 * Hook compartilhado para navegação entre etapas do formulário de proposta
 * Detecta automaticamente se está em create ou update
 */
export function useProposalNavigation(options: UseProposalNavigationOptions = { mode: 'create' }) {
  const navigate = useNavigate();
  const location = useLocation();

  const getBasePath = () => {
    if (options.mode === 'update' && options.proposalId) {
      return `/commercial/proposal/form/update/${options.proposalId}`;
    }
    if (location.pathname.includes('/update/')) {
      return location.pathname.split('?')[0];
    }
    return '/commercial/proposal/form/create';
  };

  const basePath = getBasePath();

  const goToStep = (
    step: 'client' | 'credit-analysis' | 'cart' | 'config' | 'delivery' | 'resume',
  ) => {
    navigate(`${basePath}?step=${step}`);
  };

  const goToClient = () => goToStep('client');
  const goToCreditAnalysis = () => goToStep('credit-analysis');
  const goToCart = () => goToStep('cart');
  const goToConfig = () => goToStep('config');
  const goToDelivery = () => goToStep('delivery');
  const goToResume = () => goToStep('resume');

  return {
    basePath,
    goToStep,
    goToClient,
    goToCreditAnalysis,
    goToCart,
    goToConfig,
    goToDelivery,
    goToResume,
  };
}
